import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import DesktopSidebar from './DesktopSidebar';
import ConversationsPanel from './ConversationsPanel';

export default function DesktopLayout({ children }) {
  const { user } = useAuth();
  const [expanded, setExpanded] = useState(
    () => localStorage.getItem('wtSidebarExpanded') !== 'false'
  );
  const [showChat, setShowChat] = useState(false);

  const sidebarW = expanded ? 220 : 64;

  useEffect(() => {
    document.documentElement.style.setProperty('--sidebar-w', `${sidebarW}px`);
    return () => document.documentElement.style.removeProperty('--sidebar-w');
  }, [sidebarW]);

  const toggle = () => {
    const next = !expanded;
    setExpanded(next);
    localStorage.setItem('wtSidebarExpanded', String(next));
  };

  return (
    <div style={{ display: 'flex', height: '100dvh', overflow: 'hidden' }}>
      <DesktopSidebar
        expanded={expanded}
        onToggle={toggle}
        onChatOpen={() => setShowChat(true)}
        currentUser={user}
      />
      <main style={{ flex: 1, overflowY: 'auto', position: 'relative', minWidth: 0 }}>
        {children}
      </main>
      {showChat && <ConversationsPanel onClose={() => setShowChat(false)} />}
    </div>
  );
}
